import React from 'react';
import PropTypes from 'prop-types';

const EmailShare = ({ color = '#647A85', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={31} height={31} fill="none" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M26.75 7.391H4.25c-1.036 0-1.875.84-1.875 1.875v13.75c0 1.036.84 1.875 1.875 1.875h22.5c1.035 0 1.875-.84 1.875-1.875V9.266c0-1.035-.84-1.875-1.875-1.875Z"
    />
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="m28 8.016-12.5 10-12.5-10" />
  </svg>
);

EmailShare.propTypes = {
  color: PropTypes.string
};

export default EmailShare;
